import React from 'react';
import styles from './PhotoMatchesModal.module.css';

export default function PhotoMatchesModal({ attendees, onClose }) {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h3>Matched Attendees</h3>
        <div className={styles.grid}>
          {attendees.length === 0 ? (
            <div style={{ color: '#6b7280', fontSize: '1.1rem' }}>No matches found.</div>
          ) : (
            attendees.map((a, i) => (
              <div key={i} className={styles.card}>
                <img src={`https://arnd-development.s3.us-west-1.amazonaws.com/${a.picture}`} alt={a.name} className={styles.avatar} />
                <div className={styles.name}>{a.name}</div>
              </div>
            ))
          )}
        </div>
        <button className={styles.closeBtn} onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
